import React, { Component } from "react";
import "antd/dist/antd.css";
import Listing from "../../Images/listing.png";
import Uploaded from "../../Images/uploaded.png";
import Uploadlisting from "../../Images/uploadlisting.png";
import { Form, Upload, Button, Icon, Spin, message, Popconfirm } from "antd";
import { Row, Col } from "antd";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import Amplify, { Storage } from "aws-amplify";
import awsConfigure from "../../Config/AwsConfig";
import Docsample from "../../Images/pdf.jpg";
import { updateCustomerOrCarrierDetails } from "../../api/OraganizationApis";
Amplify.configure(awsConfigure);

class Documentation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      docKeys: { coi: [], w9: [], nda: [] },
      fileList: [],
      uploading: false,
      documentsUploaded: false,
      coiUploaded: false,
      w9Uploaded: false,
      tcUploaded: false,
      ndaUploaded: false,
      uploadName: "",
      pageLoading: false,
      coiDisabled: false,
      w9Disabled: true,
      ndaDisabled: true,
    };
  }
  handleUpload = () => {
    if (
      this.state.docKeys.coi.length === 1 &&
      this.state.docKeys.w9.length === 1
    ) {
      this.setState({
        uploading: true,
      });
      let data = {
        entityData: {
          carrierFiles: {
            documents: this.state.docKeys,
          },
        },
      };
      // console.log(data);
      updateCustomerOrCarrierDetails(this.state.orgDetails["id"], data).then(
        (result) => {
          if (result.success) {
            this.setState({
              documentsUploaded: true,
            });
            localStorage.setItem(
              "orgDetails",
              JSON.stringify(result.data.data)
            );
            this.props.history.push("/carrier_app/truck");
          } else {
            console.log(result.errors);
          }
        }
      );
    } else {
      const fileName = this.state.docKeys.coi.length < 1 ? "COI" : "W9";
      message.error(`Please Upload ${fileName} File`);
    }
    // this.state.fileList.map(async (file, index) => {
    //   if (file["fileBelongsTo"]) {
    //     fileName = orgDetails["id"] + "_" + file["name"];
    //     await Storage.put(fileName, file, {
    //       contentType: file.type,
    //     }).then(result => {
    //       docKeys[file["fileBelongsTo"]].push(result.key)
    //       console.log(this.state.fileList.length, index + 1, count)
    //       if (this.state.fileList.length === 3 && this.state.fileList.length === count) {
    //         let data = {
    //           "entityData": {
    //             "carrierFiles": {
    //               "documents": docKeys
    //             }
    //           }
    //         }
    //         console.log(data);
    //         updateCustomerOrCarrierDetails(orgDetails["id"], data)
    //           .then(result => {
    //             if (result.success) {
    //               this.setState({
    //                 documentsUploaded: true
    //               })
    //               getCustomerOrCarrierDetails(orgDetails["id"])
    //                 .then(result => {
    //                   if (result.success) {
    //                     localStorage.setItem("orgDetails", JSON.stringify(result.data));
    //                     this.props.history.push('/carrier_app/truck');
    //                   }
    //                 });
    //             } else {
    //               console.log(result.errors);
    //             }
    //           });
    //       }
    //       count += 1;
    //     })
    //       .catch(err => console.log(err));
    //   }
    // });
  };

  fileDownload = async (fileName) => {
    this.setState({
      pageLoading: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, fileName)
    );
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    this.setState({
      pageLoading: false,
    });
    return a;
  }

  uploadImage = async (options) => {
    const { onSuccess, file, filename } = options;
    if (file.type === "application/pdf") {
      let fileName =
        this.state.orgDetails["id"] + "_" + filename + "_" + file["name"];
      await Storage.put(fileName, file, {
        contentType: file.type,
      }).then((result) => {
        let docKeys = this.state.docKeys;
        docKeys[filename].push(result.key);
        onSuccess(file);
        let nextUploads = {
          coi: "w9Disabled",
          w9: "ndaDisabled",
          nda: "ndaDisabled",
        };
        this.setState({
          docKeys,
          [nextUploads[filename]]: false,
        });
        return true;
      });
    }
  };

  handleDelete = async (info, key) => {
    const { originFileObj } = info;
    console.log(this.state.docKeys, key);
    await Storage.remove(key, originFileObj, {
      contentType: originFileObj.type,
    }).then((result) => {
      let docKeys = this.state.docKeys;
      docKeys[key] = [];
      this.setState({ docKeys });
      message.success(`File removed successfully`);
      return true;
    });
  };
  render() {
    const firstupload = {
      name: "coi",
      showRemoveIcon: false,
      beforeUpload: (file) => {
        console.log(this.state.docKeys);
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
          message.error(`${file.name} is not a pdf file`);
        }
        return isPDF;
      },
      onChange(info) {
        if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === "done") {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === "error") {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
      customRequest: this.uploadImage,
      onRemove: (info) => {
        // this.handleDelete(info, "coi");
        if (info.type === "application/pdf") {
          this.handleDelete(info, "coi");
        }
      },
    };
    const secondupload = {
      name: "w9",
      showRemoveIcon: false,
      beforeUpload: (file) => {
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
          message.error(`${file.name} is not a pdf file`);
        }
        return isPDF;
      },
      onChange(info) {
        if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === "done") {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === "error") {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
      customRequest: this.uploadImage,
      onRemove: (info) => {
        if (info.type === "application/pdf") {
          this.handleDelete(info, "w9");
        }
      },
    };

    const fourthupload = {
      name: "nda",
      showRemoveIcon: false,
      beforeUpload: (file) => {
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
          message.error(`${file.name} is not a pdf file`);
        }
        return isPDF;
      },
      onChange(info) {
        if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === "done") {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === "error") {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
      customRequest: this.uploadImage,
      onRemove: (info) => {
        if (info.type === "application/pdf") {
          this.handleDelete(info, "nda");
        }
      },
    };

    const { uploading } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <div className="Docdiv">
          <Spin spinning={this.state.pageLoading}>
            <h3
              className="Docheading"
              style={{ fontSize: "30px", lineHeight: "30px" }}
            >
              Documentation
            </h3>
            <p
              className="Docpara"
              style={{ fontSize: "17px", color: "#7B8190" }}
            >
              Please, upload documents to finish registration process
            </p>
            <Row type="flex" justify="start">
              <Col xs={24} sm={24} md={6} lg={6} className="DocumentsCol">
                <div className="DocumentDivSelect">
                  {this.state.documentsUploaded ? (
                    <>
                      <img src={Uploaded} className="Circle" alt="img" />
                    </>
                  ) : (
                    <>
                      <img
                        src={Uploadlisting}
                        className="Circle"
                        alt="Upload icon"
                      />
                    </>
                  )}
                  <h3>Documents</h3>
                </div>
                <div className="DocumentDivUnselect">
                  <img
                    src={Uploadlisting}
                    className="Circle"
                    alt="Upload icon"
                  />
                  <h3>Trucks</h3>
                </div>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={16}
                lg={16}
                style={{
                  backgroundColor: "white",
                  // height: "500px",
                  borderRadius: "10px",
                  padding: "40px",
                }}
                className="documentation-documents-section"
              >
                <div>
                  <h3>Documents</h3>
                  <p style={{ fontSize: "17px", color: "#7B8190" }}>
                    Please, upload documents to finish registration process
                  </p>
                  <p style={{ fontSize: "20px", color: "#7B8190" }}>
                    I'm uploading:
                  </p>
                  <div>
                    <Form onSubmit={this.handleSubmit}>
                      <Form.Item>
                        {getFieldDecorator("coi")}
                        <Row>
                          <Col span={8}>
                            {this.state.coiUploaded ? (
                              <>
                                <img
                                  src={Uploaded}
                                  style={{ marginRight: 10 }}
                                  alt="img"
                                />
                                COI
                              </>
                            ) : (
                              <>
                                <img
                                  src={Listing}
                                  style={{ marginRight: 10 }}
                                  alt="img"
                                />
                                COI
                              </>
                            )}
                          </Col>
                          <Col span={6}></Col>
                          <Col span={10}>
                            <Upload name="coi" {...firstupload} accept=".pdf">
                              <Button
                                onClick={() => {
                                  this.setState({ uploadName: "coi" });
                                }}
                                disabled={this.state.coiDisabled}
                              >
                                <Icon type="upload" />
                                Upload
                              </Button>
                            </Upload>
                          </Col>
                          <p style={{ color: "black" }}>
                            COI (Must have a workers comp policy for approval)
                          </p>
                        </Row>
                      </Form.Item>
                      <Form.Item>
                        {getFieldDecorator("w9")}
                        <Row>
                          <Col span={8}>
                            {this.state.w9Uploaded ? (
                              <>
                                <img
                                  src={Uploaded}
                                  style={{ marginRight: 10 }}
                                  alt="img"
                                />
                                W-9
                              </>
                            ) : (
                              <>
                                <img
                                  src={Listing}
                                  style={{ marginRight: 10 }}
                                  alt="img"
                                />
                                W-9
                              </>
                            )}
                          </Col>
                          <Col span={6}></Col>
                          <Col span={10}>
                            <Upload name="w9" {...secondupload} accept=".pdf">
                              <Button
                                onClick={() => {
                                  this.setState({ uploadName: "w9" });
                                }}
                                disabled={this.state.w9Disabled}
                              >
                                <Icon type="upload" />
                                Upload
                              </Button>
                            </Upload>
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item>
                        {getFieldDecorator("nda")}
                        <Row>
                          <Col span={8}>
                            {this.state.ndaUploaded ? (
                              <>
                                <img
                                  src={Uploaded}
                                  style={{ marginRight: 10 }}
                                  alt="img"
                                />
                                NDA
                              </>
                            ) : (
                              <>
                                <img
                                  src={Listing}
                                  style={{ marginRight: 10 }}
                                  alt="img"
                                />
                                NDA
                              </>
                            )}
                          </Col>
                          <Col span={6}>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.fileDownload("PrefilledNDA.pdf");
                              }}
                            >
                              <h4
                                style={{
                                  color: "#7B8190",
                                  fontSize: "13px",
                                  textAlign: "center",
                                }}
                              >
                                Download NDA &nbsp;{" "}
                                <img
                                  src={Docsample}
                                  alt="Doc"
                                  title="Download"
                                  style={{ width: "25px", height: "30px" }}
                                />
                              </h4>
                            </span>
                          </Col>
                          <Col span={10}>
                            <Upload name="nda" {...fourthupload} accept=".pdf">
                              <Button
                                onClick={() => {
                                  this.setState({ uploadName: "nda" });
                                }}
                                disabled={this.state.ndaDisabled}
                              >
                                <Icon type="upload" />
                                Upload
                              </Button>
                            </Upload>
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item
                        style={{ textAlign: "center", marginTop: "2%" }}
                      >
                        <Button
                          onClick={this.handleUpload}
                          disabled={this.state.docKeys["nda"].length === 0}
                          loading={uploading}
                          className="adddriver"
                        >
                          Submit
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </Spin>
        </div>
      </div>
    );
  }
}

export default Form.create({ name: "documentation" })(
  withAppContext(withRouter(Documentation))
);
